import React from 'react';
import { Button } from '@mui/material';
import { openMeet, meetLink } from './meetUtils';

const JoinMeetButton = () => meetLink !== '' ? <Button variant='contained' color='primary' onClick={openMeet}>
  Help Meet
</Button> : '';
;

export default JoinMeetButton;